import React, { useState } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import "./InvestmentNews.scss";
import moment from "moment/dist/moment";
import NewsImg1 from "../../../images/StaticPage/news-img1.jpg";
import NewsImg2 from "../../../images/StaticPage/news-img2.jpg";
import NewsImg3 from "../../../images/StaticPage/news-img3.jpg";
import { useStaticQuery, graphql } from "gatsby";
import ReactMarkdown from "react-markdown"
import ImageTransform from "@Components/common/ggfx-client/module/components/image-transform";
import { NEWS_PAGE_URL } from "@Components/common/site/constants";
import {ImageModule} from "@Components/common/Image_Module";

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import Slider from "react-slick";
const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const items = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 0.3
        }
    }
}

const MotionColumn = motion(Col)

const FilterGallery = (props) => {
    const settings = {
        dots: false,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 9999,
    
          },
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: false,
              dots: true,
            },
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: false,
              dots: true,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: false,
              dots: true,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: false,
              dots: true,
            },
          },
        ],
      }
    const data = useStaticQuery(graphql`
    query{
      glstrapi {
        blogs(sort:"Date:DESC", publicationState: LIVE, where: {Publish: true}, limit: 3) {
            id
            imagetransforms
            ggfx_results {
                id
                content_type
                transforms
                src_import_url
                src_cftle
                field
            }
            Title
            URL
            Date
          Banner_Video
          Banner_Image {
            alternativeText
            url
          }
          Category
      
        }
      }
    }
    `);

    const [news, setNews] = useState(data.glstrapi?.blogs)

    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => (
                <motion.section
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={containerVariants}
                >
                    <React.Fragment>
                        <section className="InvestmentNews-section">
                            <Container>
                                <Row>
                                    <Col lg={12}>
                                        <div className="content-how-can-we-help">
                                            <ScrollAnimation animateOnce={true} animateIn='fadeInUp'>
                                                <h2>{props.Title}</h2>
                                            </ScrollAnimation>
                                        </div>
                                    </Col>
                                </Row>
                                <div className="mobile-view-only">
                                <Slider {...settings}>
                                {news.map(list => {
                                        let processedImages = JSON.stringify({});
                                        if (list?.imagetransforms?.Image_Transforms) {
                                            processedImages = list.imagetransforms.Image_Transforms;
                                        }
                                        return (
                                            <div variants={items}>
                                                <Link className="news-list" to={NEWS_PAGE_URL.alias + '/' + list.URL}>
                                                    <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                                                        <div className="news-card">
                                                            <div className="news-card-content">
                                                                <span className="news-date">{moment(list.Date).format('DD MMMM YYYY')}</span>
                                                                <h6 className="news-heading">{list.Title}</h6>
                                                            </div>
                                                            <div className="item-image-wrrapper img-hover-zoom">
                                                                <ImageModule ImageSrc={list?.Banner_Image} attr={{ alt: list.Title }} ggfx_results={list?.ggfx_results} imagename="blog.Image.smalltile" strapi_id={list.id} />

                                                                {/* <ImageTransform imagesources={list?.Banner_Image?.url} renderer="srcSet" imagename='blog.Image.smalltile'
                                                                    attr={{ alt: list.Banner_Image?.alternativeText, className: '' }}
                                                                    imagetransformresult={processedImages} id={list.id} >

                                                                </ImageTransform> */}
                                                                <span className="news-category-tag">{list.Category}</span>
                                                            </div>
                                                        </div>
                                                    </ScrollAnimation>
                                                </Link>
                                            </div>
                                        )
                                    })
                                    }
                                    </Slider>
                                    </div>
                                <div className="non-mobile-view-only">
                                <Row className="filter-item-rows">

                                    {news.map(list => {
                                        let processedImages = JSON.stringify({});
                                        if (list?.imagetransforms?.Image_Transforms) {
                                            processedImages = list.imagetransforms.Image_Transforms;
                                        }
                                        return (
                                            <MotionColumn md={6} lg={4} variants={items}>
                                                <Link className="news-list" to={NEWS_PAGE_URL.alias + '/' + list.URL}>
                                                    <ScrollAnimation animateOnce={true} animateIn="fadeIn">
                                                        <div className="news-card">
                                                            <div className="news-card-content">
                                                                <span className="news-date">{moment(list.Date).format('DD MMMM YYYY')}</span>
                                                                <h6 className="news-heading">{list.Title}</h6>
                                                            </div>
                                                            <div className="item-image-wrrapper img-hover-zoom">
                                                                <ImageModule ImageSrc={list?.Banner_Image} attr={{ alt: list.Title }} ggfx_results={list?.ggfx_results} imagename="blog.Image.smalltile" strapi_id={list.id} />
                                                                {/* <ImageTransform imagesources={list?.Banner_Image?.url} renderer="srcSet" imagename='blog.Image.smalltile'
                                                                    attr={{ alt: list.Banner_Image?.alternativeText, className: '' }}
                                                                    imagetransformresult={processedImages} id={list.id} >

                                                                </ImageTransform> */}
                                                                <span className="news-category-tag">{list.Category}</span>
                                                            </div>
                                                        </div>
                                                    </ScrollAnimation>
                                                </Link>
                                            </MotionColumn>
                                        )
                                    })
                                    }
                                </Row>
                                </div>
                            </Container>
                        </section>
                    </React.Fragment>
                </motion.section>
            )}
        </InView>
    )
}

export default FilterGallery;